<div class="tw-relative tw-overflow-hidden">
  <button
    type="button"
    mat-icon-button
    class="ai-credits-modal-close tw-absolute tw-top-[5px] tw-right-[5px] lg:!tw-top-2.5 lg:!tw-right-2.5 tw-w-[25px] tw-h-[25px] lg:!tw-w-[35px] lg:!tw-h-[35px] tw-z-[2] tw-p-0 tw-bg-black/10 tw-rounded-[5px]"
    (click)="close()"
    aria-label="Close"
  >
    <mat-icon svgIcon="close" class="medium"></mat-icon>
  </button>

  <div class="tw-flex tw-flex-col lg:!tw-flex-row">
    <!-- Art image — top on mobile, right side on desktop -->
    <div
      class="tw-hidden lg:!tw-h-auto lg:!tw-w-1/2 tw-flex-none lg:!tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden"
    >
      <img
        src="/images/generate-with-ai.gif"
        alt="AI Credits illustration"
        class="tw-w-full tw-h-auto tw-object-fill tw-relative tw-z-[1]"
      />
    </div>

    <!-- Text content -->
    <div
      class="lg:!tw-w-1/2 tw-py-[30px] tw-px-[30px] md:!tw-py-[100px] md:!tw-px-[52px] tw-flex tw-flex-col tw-justify-center lg:!tw-order-first"
    >
      <rv-badge
        class="tw-mb-6"
        color="blue"
        icon="requires-upgrade"
        text="Unlock more AI Credits"
      />

      <h2
        class="ai-credits-modal-title tw-text-2xl tw-font-bold tw-m-0 tw-mb-6 tw-leading-none"
      >
        Want More AI Credits?
      </h2>

      <p
        class="ai-credits-modal-body tw-text-sm tw-leading-relaxed tw-m-0 tw-mb-0"
      >
        AI-generated presentations use credits. Every plan includes a set
        amount, with higher tiers offering more. Need extra? You can purchase
        additional credits anytime.
      </p>

      @if (data.hasPlan && !data.canModifyPlan) {
        <p class="tw-text-green-700 tw-font-medium tw-mt-2">
          Contact your parent company admin to increase the credit cap or
          upgrade your company plan.
        </p>
      }

      <div
        class="tw-flex tw-flex-col sm:!tw-flex-row tw-items-stretch tw-mt-6 sm:!tw-items-center tw-gap-[7.5px]"
      >
        @if (!data.hasPlan) {
          <button rv-button class="sm:!tw-min-w-[180px]" (click)="seePlans()">
            See Plans
          </button>
        } @else if (data.canModifyPlan) {
          <button
            rv-button
            class="sm:!tw-min-w-[180px]"
            (click)="purchaseCredits()"
          >
            Get More Credits
          </button>
        } @else {
          <button
            rv-button
            class="sm:!tw-min-w-[180px]"
            [mat-dialog-close]="false"
          >
            Okay, Got It!
          </button>
        }
      </div>
    </div>
  </div>
</div>
